import { TDAPositionsReportTableFilters } from '../../../models/types'

export const selectDAPositionsTableReportingFilters = ({
  reportingFilters: reportingDAPositionsTableFiltersState,
}: {
  reportingFilters: TDAPositionsReportTableFilters
}): TDAPositionsReportTableFilters => reportingDAPositionsTableFiltersState
